// import Vue from 'vue'
import axios from "../helpers/axios";
import router from "../router";

// Estados por defectos para mensajes (varaibles globales en el store  de mensajeria)
export default {
  // para sirve para acceder  mapstate de la siguiente forma para lso modulos ...(mapState 'mensaje', ['mensaje'])
  namespaced: true,

  state: {
    // accessToken: null,
    logingIn: false,
    loginError: false,
    loginMessage: "hola",
    loginPerfil: [],
    subModuloEvento: {},
    getSubmodulo: {},
  },

  mutations: {
    setSubmodulo: (state, object) => {
      state.getSubmodulo = object;
    },
    // new login
    loginStart(state) {
      state.logingIn = true;
    },

    loginStop(state, errorMessage) {
      state.logingIn = false;
      state.loginError = true;
      state.loginMessage = errorMessage;
    },

    loginLimipiar(state) {
      state.loginError = false;
      state.loginMessage = null;
    },

    logout(state) {
      state.logingIn = false;
      sessionStorage.clear();
      // limpiar la Session Store
      //  state.accessToken = null;
    },
    // Actualizado el perfil
    usuarioPerfil(state, perfil) {
      state.loginPerfil = perfil;
    },
  },

  actions: {
    limpiarLogin({ commit }) {
      commit("loginLimipiar");
    },
    // limpiar Error Login

    // new login
    verificarSession({ commit }, loginData) {

      let urlLogin = "/sistema/main/login/";
      let nuevaRouterHome = "/home";
      let routerHome = nuevaRouterHome + "/?id=" + new Date().getTime();

      axios
        .post(urlLogin, { ...loginData })
        .then((response) => {
          //commit('loginStop', null);
          sessionStorage.clear();

          let usuario = response.data.usuario;
          let periodos_actuales = response.data.periodos_actuales;
          let ipUsuario = response.data.ipUsuario;

          if (usuario) {

            commit("loginStart");
            
            sessionStorage.setItem("token", loginData.token);
            sessionStorage.setItem("autentificado", true);
            sessionStorage.setItem("id", usuario.id);
            sessionStorage.setItem("usu_usuario", usuario.usu_usuario);
            sessionStorage.setItem("token_usuario", loginData.token);
            sessionStorage.setItem("ip_usuario", ipUsuario);
            sessionStorage.setItem("expiracion", "2025-01-01");
            sessionStorage.setItem("id_ano_lectivo", usuario.id_ano_lectivo);
            sessionStorage.setItem("id_us_idioma", usuario.id_us_idioma);
            sessionStorage.setItem("us_idioma", usuario.us_idioma);
            sessionStorage.setItem("id_colegio_idioma", usuario.id_colegio_idioma);
            sessionStorage.setItem("colegio_idioma", usuario.colegio_idioma);
            // usuario Perfil
            sessionStorage.setItem("id_perfil", usuario.id_perfil);
            sessionStorage.setItem("webmaster", usuario.es_webmaster);
            sessionStorage.setItem("descripcion_perfil",usuario.descripcion_perfil);
            sessionStorage.setItem("licencia_perfil", usuario.licencia_perfil);
            sessionStorage.setItem("master_ck1", usuario.master_ck1);
            sessionStorage.setItem("master_colegio", usuario.master_colegio);
            // usuario Colegio
            sessionStorage.setItem("id_pais", usuario.id_pais);
            sessionStorage.setItem("id_colegio", usuario.id_colegio);
            sessionStorage.setItem("nombre_colegio", usuario.nombre_colegio);
            sessionStorage.setItem("logo_colegio", usuario.logo_colegio);
            sessionStorage.setItem("slogan_colegio", usuario.slogan_colegio);
            // Datos Básicos
            sessionStorage.setItem("id_persona", usuario.id_persona);
            sessionStorage.setItem("nombre_persona", usuario.nombre_persona);
            sessionStorage.setItem("ape1_persona", usuario.ape1_persona);
            sessionStorage.setItem("ape2_persona", usuario.ape2_persona);
            sessionStorage.setItem("numdoc_persona", usuario.numdoc_persona);
            sessionStorage.setItem("ruta_avatar_persona", usuario.ruta_avatar_persona);
            sessionStorage.setItem("avatar_persona", usuario.avatar_persona);
            sessionStorage.setItem("correo_persona", usuario.correo_persona);
            sessionStorage.setItem("fecnac_persona", usuario.fecnac_persona);
            sessionStorage.setItem("telf_persona", usuario.telf_persona);
            sessionStorage.setItem("sexo_persona", usuario.sexo_persona);
            sessionStorage.setItem("desc_tipo_usuario", usuario.desc_tipo_usuario);
            sessionStorage.setItem("periodos_actuales", periodos_actuales);
            sessionStorage.setItem("id_modulo", 3);
            sessionStorage.setItem("id_submodulo", 132);

            // Verificar si ya estás en /home antes de hacer push
            if (router.currentRoute.path !== routerHome) {
              router.push(routerHome);
            }
          } else {
            console.log('no se existe usuario');
            commit("loginStop", "No Existe el Usuario o Contraseña");
          }
        })
        .catch((e) => {
          sessionStorage.clear();
          commit("loginStop", e);
        });
    },

    async logout({ commit }) {
      //sessionStorage.removeItem('accessToken');
      let data = {
        token: sessionStorage.getItem("token"),
      };
      await axios.post("/sistema/main/logout", data);
      commit("logout");
      router.push("/login");
    },

    doLoginOriginal({ commit }, loginData) {
      commit("loginStart");

      axios
        .post("/sistema/usuario/login/", {
          ...loginData,
        })

        .then((response) => {
          commit("loginStop", null);

          if (response.data) {
            sessionStorage.setItem(
              "accessToken",
              JSON.stringify(response.data)
            );
            commit("updateAccessToken", response.data);
            router.push("/Home");
          } else {
            alert("error en sesion ");
          }
        })

        .catch((error) => {
          commit("loginStop", error.response.data.error);
        });
    },

    async validaLogin() {
      let loginData = this.datosUsuario;

      try {
        let response = await axios.post("/sistema/main/login/", loginData);

        if (response.data) {
          sessionStorage.setItem("accessToken", JSON.stringify(response.data));

          this.$router.replace("home");
        } else {
          alert("Usuario o clave incorrectos");
        }
      } catch (error) {
        console.log("ENTRA AL CATCH");
        console.log(error);
      }
    },

    // validacion de acceso de Modulo y Submodulo por componente
    async parametroComponente({ state }) {
      let config = {
        id_perfil: sessionStorage.id_perfil,
        id_modulo: sessionStorage.id_modulo,
        id_submodulo: sessionStorage.id_submodulo,
        id_usuario: sessionStorage.id,
        master_colegio: sessionStorage.master_colegio,
        token: sessionStorage.token_usuario,
      };
      try {
        let response = await axios.post(
          "/sistema/main/componenteEvento/",
          config
        );
        if (response.data) {
          state.subModuloEvento = response.data;
        } else {
          //state.subModuloEvento = {};
        }
      } catch (error) {
        state.subModuloEvento = {};
      }
    },
  },

  getters: {
    componenteEvento: (state) => {
      return state.subModuloEvento;
    },
  },
};
